import React, { useState } from "react";
import { Modal } from "antd";
import { deleteReport } from "../../services/reports";

const DeleteModal = ({ open, setOpen, id, setUpdate }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(
    "Are you sure you want to delete it?"
  );

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const response = await deleteReport(id);
    console.log(response);
    
    if (response.success) {
      setConfirmLoading(false);
      setUpdate(true);
      setOpen(false);
    }
  };


  return (
    <>
      <Modal
        title="PDF Deletion"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </Modal>
    </>
  );
};

export default DeleteModal;
